import { selector } from 'recoil'
import unitsAtom from '@/pages/MDM/atoms/units.atom.ts'
import unitInstancesAtom from '@/pages/MDM/atoms/units.instances.atom.ts'
import { IMDMUnit, IMDMUnitInstance } from '@/pages/MDM/mdm.types.ts'

const unitIdToInstancesMap = selector({
  key: 'unitIdToInstancesMap',
  get: ({ get }) => {
    const units = get(unitsAtom).items
    const instances = get(unitInstancesAtom).items
    const result: Record<IMDMUnit['id'], IMDMUnitInstance[]> = {}

    for (const instance of instances) {
      if (Array.isArray(result[instance.unitId])) {
        result[instance.unitId].push(instance)
      } else {
        result[instance.unitId] = [instance]
      }
    }

    for (const unit of units) {
      if (!Array.isArray(result[unit.id])) {
        result[unit.id] = []
      }
    }

    return result
  },
})

const mdmSelectors = { unitIdToInstancesMap }
export default mdmSelectors
